import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PromoProductHistory } from '../../interfaces/PromoProduct.interface';
import { PromoProductItem } from '../../interfaces/PromoItem.interface';

@Injectable()
export class PromoProductsService {
  constructor( private http: HttpClient ) {}
  public getPromoProductsHistory(userId: string): Observable<PromoProductHistory[]> {
      return this.http.get<PromoProductHistory[]>(`/users/${userId}/promo_product_history`)
      .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message)) ))
  }
  public getPromoProductHistory(userId: string, teamId: number): Observable<PromoProductItem[]> {
    return this.http.get<PromoProductItem[]>(`/users/${userId}/promo_product_history/${teamId}`)
    .pipe(catchError((error: HttpErrorResponse) => _throw(new Error(error.message)) ))
  }
}



// WEBPACK FOOTER //
// ./src/providers/promo-products/promo-products.service.ts